module.exports = {
  categories: {
    activity: 'Aktivität',
    nature: 'Tiere & Natur',
    places: 'Reisen & Orte',
    recent: 'Häufig verwendet',
    foods: 'Essen & Trinken',
    objects: 'Objekte',
    custom: 'Benutzerdefiniert',
    search: 'Suchergebnisse',
    symbols: 'Symbole',
    flags: 'Flaggen',
    people: 'Smileys & Personen',
  },
  search: 'Suche',
  notfound: 'Keine Emojis gefunden',
}
